import React from "react";
import { useMaintenance } from "../../contexts/MaintenanceContext";

const formatUntil = (value) => {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

const MaintenanceBanner = () => {
  const { maintenanceMode, message, until } = useMaintenance();

  if (!maintenanceMode) {
    return null;
  }

  const formattedUntil = formatUntil(until);

  return (
    <div className="fixed top-0 left-0 right-0 z-[120] border-b border-amber-300 bg-amber-50 text-amber-900 shadow-sm">
      <div className="mx-auto max-w-7xl px-4 py-3">
        <p className="text-sm font-semibold">We&apos;re performing scheduled maintenance.</p>
        {message ? <p className="mt-1 text-sm">{message}</p> : null}
        {formattedUntil ? <p className="mt-1 text-xs">Expected recovery: {formattedUntil}</p> : null}
      </div>
    </div>
  );
};

export default MaintenanceBanner;
